import React, { ButtonHTMLAttributes, forwardRef } from "react";
import styled from "styled-components";
import { Ellipsis, EllipsisVertical } from "lucide-react";
import { NEW_LOOK_ICON_STROKE } from "common/NewLook/layout.ts";

/**
 * The new look's "more actions" trigger for cards, rows and drawer headers: a 32px round
 * ghost button with a lucide vertical ellipsis (replaces the heavy antd
 * glyph). Forwards the props and ref a Dropdown adds to its trigger.
 */
const NewLookKebab = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & {
    /** Horizontal dots, for drawer headers (next to the close button). */
    horizontal?: boolean;
  }
>(({ horizontal, ...props }, ref) => (
  <Button ref={ref} type="button" {...props}>
    {horizontal ? (
      <Ellipsis size={18} strokeWidth={NEW_LOOK_ICON_STROKE} />
    ) : (
      <EllipsisVertical size={18} strokeWidth={NEW_LOOK_ICON_STROKE} />
    )}
  </Button>
));

export default NewLookKebab;

const Button = styled.button`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  color: ${(p) => p.theme.colors.secondaryText};
  transition: background-color 150ms, color 150ms;
  &:hover,
  &:active,
  &.ant-dropdown-open {
    color: ${(p) => p.theme.colors.titleColor};
    background: ${(p) => p.theme.colors.cardLightBgColor};
  }
  &:focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.primaryBlue};
    outline-offset: 1px;
  }
`;
